import { Building2 } from 'lucide-react';
import { RequireActiveOrganization } from '@/components/shared/RequireActiveOrganization';
import { buildCoreOrganizationNavItems } from '@/components/layout/NavBar/nav-items';
import { useActiveOrgSlug } from '@/lib/useOrgRoutes';
import { ROUTES } from '@/lib/routes';
import { ResourceGroupOverviewPage } from '@/pages/resources/ResourceGroupOverviewPage';

export function OrganizationOverviewPage() {
  const slug = useActiveOrgSlug();

  return (
    <RequireActiveOrganization title="Organization">
      {(org) => (
        <ResourceGroupOverviewPage
          icon={<Building2 className="h-5 w-5 text-muted-foreground" />}
          title="Organization"
          description={`Settings, members, teams, and roles for ${org.name}.`}
          coreNavItems={buildCoreOrganizationNavItems(slug)}
          group="organization"
          bottomRoutes={[ROUTES.org(slug).settings]}
        />
      )}
    </RequireActiveOrganization>
  );
}
